import {
  getIdentityRoute,
  axiosGetRequest,
  axiosPatchRequest,
  axiosDeleteRequest,
  getHealthPictureRoute,
  axiosGetPaginatedRequest,
} from '../api';
import { Reply } from '../community';
import { Consultation } from './consultation/models';
import { HealthJourneyDto } from './dtos';
import { Journal } from './journal/model';
import {
  HealthJourney,
  HealthPictureItem,
  SymptomCheckerResult,
} from './model';

const PAGE_SIZE = 8;

export const createNewJourneyCall = (healthJourney: HealthJourneyDto) => {
  return axiosPatchRequest<HealthJourneyDto, HealthJourney[]>(
    `${getIdentityRoute()}/journey`,
    healthJourney
  );
};

export const fetchHealthJourneysCall = () => {
  return axiosGetRequest<HealthJourney[]>(`${getIdentityRoute()}/journeys`);
};

export const updateHealthJourneyCall = (
  journeyId: string,
  healthJourney: HealthJourneyDto
) => {
  return axiosPatchRequest<HealthJourneyDto, HealthJourney[]>(
    `${getIdentityRoute()}/journey/${journeyId}`,
    healthJourney
  );
};
export const deleteHealthJourneyCall = (journeyId: string) => {
  return axiosDeleteRequest<string, Reply>(
    `${getIdentityRoute()}/journey/${journeyId}`
  );
};

export const fetchHealthPictureCall = (journeyId: string) => {
  return axiosGetRequest<HealthPictureItem>(
    `${getHealthPictureRoute()}/healthpicture/${journeyId}`
  );
};

export const updateHealthPictureCall = (healthPicture: HealthPictureItem) => {
  return axiosPatchRequest<HealthPictureItem, HealthPictureItem>(
    `${getHealthPictureRoute()}/healthpicture`,
    healthPicture
  );
};

export const fetchHealthJourneyTimelineCall = (
  journeyId: string,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<
    (HealthPictureItem | Consultation | Journal)[]
  >(
    `${getHealthPictureRoute()}/healthjourney/${journeyId}/timeline/${PAGE_SIZE}`,
    xMsContinuationToken
  );
};

export const deleteHistoricalHealthPictureCall = (pictureId: string) => {
  return axiosDeleteRequest<string, void>(
    `${getHealthPictureRoute()}/healthpicture/${pictureId}`
  );
};

export const fetchSymptomCheckerResultsCall = (journeyId: string) => {
  return axiosGetRequest<SymptomCheckerResult[]>(
    `${getHealthPictureRoute()}/symptomchecker/healthjourney/${journeyId}`
  );
};
